import React from 'react';
import { lightModeText, negativeRed } from "../util/style";
import { useAppContext } from "./AppContext";

const RefreshStatus: React.FC = () => {
  const {
    lastUpdateTime,
    getFont,
    darkMode,
    refreshToken,
    autoRefreshClock,
    sequenceRefreshRate,
    chartToBackgroundRefreshRatio,
    numFormat,
    marketRefreshReady,
    serverActive,
  } = useAppContext() || {};

  function formatDuration(seconds: number): string {
    const units: { label: string; value: number }[] = [
      { label: "d", value: 86400 },
      { label: "h", value: 3600 },
      { label: "m", value: 60 },
      { label: "s", value: 1 },
    ];

    const parts: string[] = [];
    let remainingSeconds = seconds;

    for (const { label, value } of units) {
      const amount = Math.floor(remainingSeconds / value);
      if (amount > 0) {
        parts.push(`${amount}${label}${amount !== 1 ? "" : ""}`);
        remainingSeconds %= value;
      }
    }

    return parts.length > 0 ? parts.join(" ") : "0 seconds";
  }

  const serviceOnline = !(autoRefreshClock > 0 && !serverActive?.current);

  return (
    <div style={{ color: darkMode ? "rgb(100,100,100)" : lightModeText }}>
      <div
        style={{
          fontSize: getFont?.(10),
          textAlign: "left",
        }}
      >
        <span>Updated:&nbsp;</span>
        {Math.floor(Date.now() / 1000) - (lastUpdateTime?.current || 0) > 0 &&
          formatDuration(
            Math.floor(Date.now() / 1000) - (lastUpdateTime?.current || 0),
          ) + " ago"}
        <span
          style={{
            color: "orange",
            fontWeight: "600",
          }}
        >
          {Math.floor(Date.now() / 1000) - (lastUpdateTime?.current || 0) === 0 &&
            "NOW"}
        </span>
      </div>

      {serviceOnline && marketRefreshReady?.current && (
        <>
          <div
            style={{
              fontSize: getFont?.(10),
              textAlign: "left",
            }}
          >
            Refresh:&nbsp;
            {numFormat?.(
              (sequenceRefreshRate *
                (1 - ((autoRefreshClock / sequenceRefreshRate) % 1))) /
                1000,
              false,
              0,
            )}
            s&nbsp;/&nbsp;Full:&nbsp;
            {numFormat?.(
              (sequenceRefreshRate *
                chartToBackgroundRefreshRatio *
                (1 -
                  ((autoRefreshClock /
                    sequenceRefreshRate /
                    chartToBackgroundRefreshRatio) %
                    1))) /
                1000,
              false,
              0,
            )}
            s
          </div>
          <div
            style={{
              fontSize: getFont?.(10),
              textAlign: "left",
            }}
          >
            <>
              Active:&nbsp;~
              {formatDuration((refreshToken * sequenceRefreshRate) / 1000)}
              &nbsp;left&nbsp;({refreshToken})
            </>
          </div>
        </>
      )}
      {!marketRefreshReady?.current && (
        <div
          style={{
            fontSize: getFont?.(10),
            textAlign: "left",
            color: negativeRed,
          }}
        >
          <span style={{ fontWeight: 600 }}>Refresh Inactive</span>
        </div>
      )}
      {!serviceOnline && (
        <div
          style={{
            fontSize: getFont?.(10),
            textAlign: "left",
            color: negativeRed,
          }}
        >
          <span style={{ fontWeight: 600 }}>Service Offline</span>
        </div>
      )}
    </div>
  );
};

export default RefreshStatus;
